const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: true,
      showAnimationDuration: 500,
      scaleMode: 'zoom',

      gallery: this.localName,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,
      preload: [1, 4],

      closeOnVerticalDrag: true,

      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addPreviousButton()
      this.addNextButton()
      this.addCloseButton()
    })
  }

  addPreviousButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-prev',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-previous',
      ariaLabel: 'Previous',
      order: 1,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.prev()
      },
    })
  }

  addNextButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-next',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-next',
      ariaLabel: 'Next',
      order: 3,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.next()
      },
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeHtml,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  get arrowSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21">
  <path fill="currentColor" d="M13.854 10.146a.5.5 0 0 1 0 .708l-3.182 3.182a.5.5 0 1 1-.708-.708l2.829-2.828-2.829-2.828a.5.5 0 1 1 .708-.708l3.182 3.182ZM6.5 10h7v1h-7v-1Z"></path>
</svg>`
  }

  get closeHtml () {
    return `<span class="pswp-Action_CloseIcon"></span>`
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
